module.exports = __webpack_public_path__ + "static/media/football_training.0e533b5f.jpg";